import React, { useState, useEffect } from "react";
import PolyProps from "./PolyPropss"; // Updated to match existing file name
import pp from "../../assets/pp.png";
import pc1 from "../../assets/pc1.png";
import pc2 from "../../assets/pc2.png";
import flagPakistan from "../../assets/pakistan.png";
import flagJapan from "../../assets/japan.png";
import flagSaudiArabia from "../../assets/saudi_arabia.png";
import flagNorway from "../../assets/norway.png";
import flagUAE from "../../assets/united_arab_emirates.png";
import flagUSA from "../../assets/united_states_of_america.png";
import s1age4 from "../../assets/s1age4.png";
import s1age7 from "../../assets/s1age7.png";
import s1age11 from "../../assets/s1age11.png";
// import s2age4 from "../../assets/s2age4.png";
import s2age7 from "../../assets/s2age7.png";
// import s2age11 from "../../assets/s2age11.png";
// import s3age4 from "../../assets/s3age4.png";
// import s3age7 from "../../assets/s3age7.png";
// import s3age11 from "../../assets/s3age11.png";
import student1 from "../../assets/student1.png";
import axios from 'axios';

const English = () => {
  const [competitionData, setCompetitionData] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch competition data from database
  useEffect(() => {
    const fetchCompetitionData = async () => {
      try {
        const response = await axios.get(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/allpolymatchcompetition`);
        if (response.data && response.data.length > 0) {
          // Filter competitions that contain "english" in the name (case insensitive)
          const englishCompetitions = response.data.filter(comp => 
            comp.Competition_Name && comp.Competition_Name.toLowerCase().includes('english')
          );
          setCompetitionData(englishCompetitions);
        }
        setLoading(false);
      } catch (error) {
        console.error('Error fetching competition data:', error);
        setLoading(false);
      }
    };

    fetchCompetitionData();
  }, []);

  const headerSection = {
    mainHeading: "English Linguistic Competition",
    // subHeading: "2025",
    mainImage: pp,
    leftImage: pc1,
    rightImage: pc2,
  };

  const upcomingCompetitionSection = {
    mainHeading: "For Our Upcoming Competition",
    subHeading: "Stay Tuned",
    competitionName: "English Linguistic Knowledge Competition",
    description:
      "The PolyMatch English Linguistic Competition ignites curiosity and celebrates the wonders of language from around the world. This exciting event brings together brilliant minds to explore concepts in grammar, vocabulary, literature, and beyond. Encouraging innovation, critical thinking, and linguistic discovery, participants deepen their language skills while building meaningful global connections in a dynamic and inspiring atmosphere",
    registerLink: "/PolymatchReg",
    flags: [
      { src: flagPakistan, alt: "Pakistan Flag" },
      { src: flagJapan, alt: "Japan Flag" },
      { src: flagSaudiArabia, alt: "Saudi Arabia Flag" },
      { src: flagNorway, alt: "Norway Flag" },
      { src: flagUAE, alt: "United Arab Emirates Flag" },
      { src: flagUSA, alt: "United States of America Flag" },
    ],
  };

  // Dynamic competition years section based on database data
  const competitionYearsSection = {
    mainHeading: "English Linguistic Competition",
    defaultYear: 2025,
    years: competitionData.map(comp => ({
      year: new Date(comp.Competition_date).getFullYear(),
      title: comp.Competition_Name,
      dates: new Date(comp.Competition_date).toLocaleDateString('en-US', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      }),
      description: comp.Competition_Description || "The PolyMatch English Linguistic Competition was a huge success, with a big rise in global participation. It was a fun, high-energy event where participants showcased their amazing language skills and passion for learning.",
      competitionId: comp.Competition_Id,
    })),
    flags: [
      { src: flagPakistan, alt: "Pakistan Flag" },
      { src: flagJapan, alt: "Japan Flag" },
      { src: flagSaudiArabia, alt: "Saudi Arabia Flag" },
      { src: flagNorway, alt: "Norway Flag" },
      { src: flagUAE, alt: "United Arab Emirates Flag" },
      { src: flagUSA, alt: "United States of America Flag" },
    ],
  };

  const winnersSection = {
    mainHeading: "Congratulations to All Winners!",
    description:
      "We're proud of every participant, and we applaud the outstanding winners who showcased exceptional skills, creativity, and determination. Your hard work truly shines—well done!",
    winners: [
      {
        year: 2025,
        image: s1age4,
        alt: "Age 4-5 Winner",
        ageCategory: "Ages 4-5",
        studentsData: [
          {
            name: "Kadi Abdulaziz",
            rank: "1st Winner",
            country: "Taif, Saudi Arabia",
            age: "5 Years",
            image: 'Polymath-images/Winners Pics/2025/English Linguistic/4 to 5/1stPosition-KadiAbdulaziz.png',
          },
          {
            name: "Noor Fatima",
            rank: "2nd Winner",
            country: "Karachi, Pakistan",
            age: "5 Years",
            image: 'Polymath-images/Winners Pics/2025/English Linguistic/4 to 5/2ndPosition-NoorFatima.png',
          },
          {
            name: "Fatima Sahreef",
            rank: "3rd Winner",
            country: "Taif, Saudi Arabia",
            age: "5 Years",
            image: 'Polymath-images/Winners Pics/2025/English Linguistic/4 to 5/3rdPosition-FatimaSahreef.png',
          },
        ],
      },
      {
        year: 2025,
        image: s1age7,
        alt: "Age 6-8 Winner",
        ageCategory: "Ages 6-8",
        studentsData: [
          {
            name: "Nayle Badar",
            rank: "1st Winner",
            country: "Sahiwal, Pakistan",
            age: "7 Years",
            image: 'Polymath-images/Winners Pics/2025/English Linguistic/6 to 8/1stPosition-NayleBadar.png',
          },
          {
            name: "Aabis Abbas",
            rank: "2nd Winner",
            country: "Islamabad, Pakistan",
            age: "6 Years",
            image: 'Polymath-images/Winners Pics/2025/English Linguistic/6 to 8/2ndPosition-AabisAbbas.png',
          },
          {
            name: "Saadi Faraz",
            rank: "3rd Winner",
            country: "Karachi, Pakistan",
            age: "8 Years",
            image: 'Polymath-images/Winners Pics/2025/English Linguistic/6 to 8/3rdPosition-SaadiFaraz.png',
          },
        ],
      },
      {
        year: 2025,
        image: s1age11,
        alt: "Age 9-11 Winner",
        ageCategory: "Ages 9-11",
        studentsData: [
          {
            name: "Laiba Riaz",
            rank: "1st Winner",
            country: "Riyadh, Saudi Arabia",
            age: "11 Years",
            image: 'Polymath-images/Winners Pics/2025/English Linguistic/9 to 11/1stPosition-LaibaRiaz.png',
          },
          {
            name: "Azlan Butt",
            rank: "2nd Winner",
            country: "Lahore, Pakistan",
            age: "10 Years",
            image: 'Polymath-images/Winners Pics/2025/English Linguistic/9 to 11/2ndPosition-AzlanButt.png',
          },
          {
            name: "Eman Omer",
            rank: "3rd Winner",
            country: "Islamabad, Pakistan",
            age: "10 Years",
            image: 'Polymath-images/Winners Pics/2025/English Linguistic/9 to 11/3rdPosition-EmanOmer.png',
          },
        ],
      },
      {
        year: 2025,
        image: s2age7,
        alt: "Age 12-15 Winner",
        ageCategory: "Ages 12-15",
        studentsData: [
          {
            name: "Falah Hamad Sahaf",
            rank: "1st Winner",
            country: "Lahore, Pakistan",
            age: "15 Years",
            image: 'Polymath-images/Winners Pics/2025/English Linguistic/12 to 15/1stPosition-FalahHamadSahaf.png',
          },
          {
            name: "Taha Shahzad",
            rank: "2nd Winner",
            country: "Madina, Saudi Arabia",
            age: "12 Years",
            image: 'Polymath-images/Winners Pics/2025/English Linguistic/12 to 15/2ndPosition-TahaShahzad.png',
          },
          {
            name: "Muneeb",
            rank: "3rd Winner",
            country: "Shahkot, Pakistan",
            age: "12 Years",
            image: 'Polymath-images/Winners Pics/2025/English Linguistic/12 to 15/3rdPosition-Muneeb.png',
          },
        ],
      },
    ],
    resultsLink: "/PolymatchResults_Linguistic",
  };

  const spotlightSection = {
    mainHeading: "Participant Spotlight",
    subHeading: " – Watch Them in Action",
    description:
      "Get inspired by the creativity, confidence, and talent of our young competitors. These videos showcase real moments from PolyMatch participants sharing their experiences, solving linguistic challenges, and celebrating success.",
    participants: [
      {
        name: "Muneeb Imran",
        compName: "English Linguistic Competition 2024",
        rank: "3rd Winner – Age Category 12 - 15",
        country: "From Pakistan",
        video: "https://www.youtube.com/shorts/WB6WwkkwIpc?si=q9cwDHFGuu8gAI_L",
      },
      {
        name: "Muhammad Aabis Abbas",
        compName: "English Linguistic Competition 2024",
        rank: "2nd Winner – Age Category 6 - 8",
        country: "From Pakistan",
        video: "https://www.youtube.com/shorts/OQfmh2ch3QI?si=UzEc6M46ogGTBhS1",
      },
      {
        name: "Muhammad Azlan Butt",
        compName: "English Linguistic Competition 2024",
        rank: "3rd Winner – Age Category 9 - 11",
        country: "From Pakistan",
        video: "https://www.youtube.com/shorts/GOEBOJzeCGE",
      },
      {
        name: "Nyle Badar",
        compName: "English Linguistic Competition 2024",
        rank: "1st Winner – Age Category 7 - 9",
        country: "From Pakistan",
        video: "https://www.youtube.com/shorts/tHuOYelAjM0",
      },
      {
        name: "Noor Fatima",
        compName: "English Linguistic Competition 2024",
        rank: "2nd Winner – Age Category 4 - 5",
        country: "From Pakistan",
        video: "https://youtube.com/shorts/mv3byuIqbSE?si=GyZVuuaE58nlhOF9",
      },
      {
        name: "Muhammad Aabis Abbas",
        compName: "English Linguistic Competition 2024",
        rank: "3rd Winner – Age Category 6 - 8",
        country: "From Pakistan",
        video: "https://youtube.com/shorts/OQfmh2ch3QI?si=UzEc6M46ogGTBhS1",
      },
    ],
  };

  // Show loading state while fetching data
  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '50vh',
        fontSize: '18px',
        color: '#666'
      }}>
        Loading competition data...
      </div>
    );
  }

  // Show message if no English competitions found
  if (!competitionData || competitionData.length === 0) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '50vh',
        fontSize: '18px',
        color: '#666',
        textAlign: 'center',
        padding: '20px'
      }}>
        <div>
          <h3>No English competitions found</h3>
          <p>Please check back later for upcoming English competitions.</p>
        </div>
      </div>
    );
  }

  return (
    <PolyProps
      headerSection={headerSection}
      upcomingCompetitionSection={upcomingCompetitionSection}
      competitionYearsSection={competitionYearsSection}
      winnersSection={winnersSection}
      spotlightSection={spotlightSection}
      text={"Upcoming Event: January 2026"}
    />
  );
};

export default English;